export class UserGebaeudeFilter {
  idPr!: number;
  idModulList: number[] = [];
  idMbMMaList: number[] = [];
  wertList: (number | null)[] = [];
  idModulAuspList: number[] = [];
  wertAuspVonList: number[] = [];
  wertAuspBisList: number[] = []; 
}
